import Box from "@material-ui/core/Box";
import React, { useEffect, useState } from "react";
import {
  Switch,
  useHistory,
  useLocation,
  useRouteMatch,
} from "react-router-dom";
import AddDiscountRequest from "../BeigeManagement/addDiscountRequest";
import AddNotificationRequest from "../BeigeManagement/addNotification";
import BeigeTabs from "../BeigeManagement/beigeManagementTabs";
import BrokerManager from "../BrokerManager/brokerManager";
import CallRequest from "../CallRequests/prospectcallRequests";
import AddCMS from "../cms/addCMS";
import CMSOverView from "../cms/cmsOverview";
import EditCMS from "../cms/editCMS";
import MenuBar from "../components/menubar";
import SideBar from "../components/sidebar";
import Prospect from "../components/tabs";
import "../index.css";
import EditInvestor from "../investment/editInvestorQuestioner";
import GoalsDashboard from "../investment/goalsdashboard";
import InvestmentDetails from "../investment/investmenDetails";
import InvestmentAdvice from "../investment/investmentAdvice";
import InvestorInvestmentProfile from "../investment/investorInvestMentProfile";
import InvestorNotifiCationManager from "../investment/investorNotifiCationManager";
import InvestorPersonalProfile from "../investment/investorPersonalProfile";
import InvestorPortFolio from "../investment/investorPortfolio";
import SubscriptionManager from "../investment/subscriptionManager";
import AddLookup from "../lookupManager/addLookup";
import LookupMaster from "../lookupManager/lookupManager";
import MyPerformance from "../profile/myPerformence";
import ActivityLog from "../prospect/activityLog";
import AddCommunicatioTimeLine from "../prospect/addCommunicationTime";
import AddPayment from "../prospect/addpayment";
import addDiscount from "../prospect/addDiscountRequest";
import AddProspect from "../prospect/addNewProspect";
import AddReview from "../prospect/addReview";
import AddTicket from "../prospect/addTicket";
import CommunicationTimeLine from "../prospect/communicationTimeline";
import CreateEmail from "../prospect/createEmail";
import CreateNotification from "../prospect/createNotification";
import EditProspect from "../prospect/editProspect";
import EditTicket from "../prospect/editTicket";
import InvestmentProfile from "../prospect/investmenProfile";
import PersonalProfile from "../prospect/personalProfile";
import ProspectDetails from "../prospect/prospectDetails";
import ProspectSatisfaction from "../prospect/prospectSatisfaction";
import ReferralDashboard from "../prospect/referalDashboard";
import ReferralManager from "../referralManager/referralManager";
import http from "../services/httpService";
import EditUser from "../userManagement/editUser";
import createFranchise from "./createFranchise";
import UserManagementTabs from "../userManagement/userTabs";
import PrivateRoute from "../utils/privateRoute";
import Executivelist from "../investment/executivelist";
import LandingPage2 from "../prospect/LandingPage2";
import GoalAdvices from "../misReport/goalAdvices";
import {
  activityLogPath,
  addCommunicatioTimeLinePath,
  addContentManagementPath,
  addDiscountOverAllPath,
  addDiscountPath,
  addEFG,
  addInvestmentPath,
  addInvestorReviewPath,
  addLookupManagerPath,
  addNotificationPath,
  addProspectPath,
  addReviewPath,
  addTheme,
  addTicketPath,
  beigeManagementPath,
  brokerManagerPath,
  callRequestsPath,
  communicatioTimeLinePath,
  contentManagementPath,
  createEmailPath,
  createNotificationPath,
  editContentManagementPath,
  editEFG,
  editInvestmentPath,
  editInvestorQuestioner,
  editProspectPath,
  editTicketPath,
  editUserPath,
  goalsDashboardPath,
  investmentAdvicePath,
  investmentDetailsPath,
  investmentDiscountPath,
  investmentPath,
  investmentPersonalProfilePath,
  investmentProfilePath,
  investmentReferalDashboardPath,
  investmentSatisfactionPath,
  investorActivityLogPath,
  investorAddCommunicatioTimeLinePath,
  investorcommunicationTimeLinePath,
  investorCreateEmailPath,
  investorCreateNotificationPath,
  investorindividualRequestPath,
  investorInvestmentProfilePath,
  investorNotifiCationManagerPath,
  investorPortFolioPath,
  lookupManagerPath,
  myPerformancePath,
  personalProfilePath,
  prospectDetailsPath,
  prospectGoalsDashboardPath,
  prospectPath,
  prospectSatisfactionPath,
  referralDashboardOverViewPath,
  referralDashboardPath,
  referralManagerPath,
  subscriptionManagerPath,
  userManagementPath,
  vantagePath,
  addPaymentPath,
  investmentAddPaymentPath,
  editInvestPath,
  investmentsPath,
  addProspectTaskPath,
  executiveListPath,
  propectexecutiveListPath,
  alltasks,
  invalltasks,
  viewInternalSupportPath,
  createfranchisepath,
  uploadecxel,
  addInternalSupportPath,
  editInternalSupportPath,
  viewMitsReportsPath,
  viewMitsChildReportsPath,
  viewSalesReportsPath,
  viewmissalesreportall,
  viewmissalesreportsdetailsPath,
  ViewNestedChildMisReportsPath,
  viewResearchReportsPath,
  createAdviseRequestPath,
  AddAdviseRequestPath,
  manualAdviceTabsPath,
  advicesPendingPath,
  adviceRequestsPath,
  ViewCdtReportsPath,
  ViewCdtParticularPath,
  ViewCDTyetToSubscribePath,
  viewSalesMisReportsPath,
  marketingpath,
  marketingparentpath,
  landingpage2Path,
  razorpyPath,
  gromocodepathPath,
  menuuploadpathPath,
  franchiseDashboard,
  addSubscriptionPath,
  investmentAddSubscriptionPath,
  delrequestspath,
  reassignRmList,
  notesReview,
  goalAdvicesStopped,
  rebalance_sell_path,
  rebalance_data_path,
  addpaymentlinks,
  rebalanceAdvicePath,
  checkstatutracking,
  callRequestsTabsPath,
  prospectcallRequestsPath,
  investorcallRequestsPath,
  subscriptiondetailsPath,
  extendsubscriptionPath,
  cdt_create_advice,
  auapath,
  portfolioReviewTabsPath,
  sentportfolioReviewPath,
  addportfolioReviewPath,
  detailviewportfolioReviewPath,
  pendingportfolioReviewPath,
  sentdetailviewportfolioReviewPath,
  onboardingoverviewPath,
} from "../utils/varialbles";
import AddEfg from "../vantage/addEfg";
import AddInvestment from "../vantage/addInvestment";
import AddTheme from "../vantage/addTheme";
import EditEFG from "../vantage/editEFG";
import EditVantage from "../vantage/editInvestment";
import InvestmentTabs from "./investmenTabs";
import InvestmentReviewTabs from "./invInvestmentTabs";
import SavVantageTabs from "./vantagetabs";
import InvestAddpayment from "../investment/investaddpayment";
import EditInvestornew from "../investment/editInvestor";
import Investments from "../investment/investments";
import ProspectTask from "../prospect/prospectTask";
import ProspectExecutivelist from "../prospect/propectexelist";
import Prospectalltasks from "../prospect/prospectalltasks";
import InvExecutivelist from "../investment/invalltasklist";
import InvAllTasklist from "../investment/invalltasklist";
import ViewInternalSupport from "./viewInternalSupport";
import AddInternalSupport from "./addInternalSupport";
import EditInternalSupport from "./editInternalSupport";
// import ViewMITSReports from "../misReport/viewMisReports";
import ViewMITSReports from "../misReport/viewmisreopts2";
// import ViewChildMitReports from "../misReport/viewMisChildReport";
import ViewChildMitReports from "../misReport/viewMisChildReport2";
import ViewSalesReports from "../misReport/viewSalesReports";
import ViewNestedChildMitReports from "../misReport/viewMisNestedChildReport";
import ViewResearchReports from "../misReport/viewResearchReport";
import CreateAdviseRequest from "../prospect/createAdviceRequest";
import AdviceRequests from "../prospect/advicesSent";
import ViewCdtReports from "../misReport/cdtReports";
import ViewParticularCdtReport from "../misReport/cdtParticularReport";
import MisSalesReportParent from "../misReport/misSalesReportParent";
import MisSalesReportChild from "../misReport/misSalesReportChild";
import MisSalesReport from "../misReport/misSalesReport";
import ViewCDTReferralToSubscribe from "../misReport/cdtReferralToSubscribe";
import Uploadexcel from "./uploadexcel";
import Marketing from "../misReport/marketing";
import { margin } from "@mui/system";
import Marketparent from "../misReport/marketparent";
import Addadvice from "../prospect/addadvice";
import Razorpy from "../Razorpy/Razorpy";
import Gromolink from "./gromolink";
import MenuUpload from "./mutualfundsUpload";
import MutualfundUpload from "./mutualfundsUpload";
import FranchiseDashboard from "../franchise/franchiseDashboard";
import AddSubscription from "../prospect/AddSubscription";
import DeleteRequest from "../investment/deleterequest";
import ReAssignRmList from "../prospect/reassignrmList";
import ManualAdviceTabs from "../maualAdvice/manualAdviceTabs";
import AdvicesPending from "../maualAdvice/advicesPending";
import NotesReview from "./notesReview";
import RebalanceSell from "../maualAdvice/rebalanceSell";
import RebalanceOverallData from "../maualAdvice/rebalanceOverallData";
import Addpaymentlinks from "./addpaymentlinks";
import RebalanceAdvice from "../investment/rebalanceAdvice";
import CheckStatus from "../investment/CheckStatus";
import TabsCallRequest from "../CallRequests/tabscallRequest";
import ProspectCallRequest from "../CallRequests/prospectcallRequests";
import InvestorCallRequest from "../CallRequests/investorcallRequest";
import Subscriptiondetails from "../investment/subscriptiondetails";
import ExtendSubscription from "../investment/extendSubscription";
import Cdtcreateadvicetabs from "../misReport/cdtcreateadvicetabs";
import Aua from "../aua/Aua";
import PortfolioReview from "../misReport/portfolioReview";
import SentportfolioReview from "../misReport/sentportfolioReview";
import AddportfolioReview from "../misReport/addportfolioReview";
import DetailviewportfolioReview from "../misReport/portfolioReview/detailviewportfolioReview";
import PendingportfolioReview from "../misReport/portfolioReview/pendingportfolioReview";
import SentdetailviewportfolioReview from "../misReport/portfolioReview/sentdetailviewportfolioReview";
import OnboardingTabs from "./OnboardingTabs";
// import ViewNestedChildMisReport from '../misReport/viewNestedChildMisReport'
// import ViewInternalSupport from "./viewInternalSupport";
// import AddInternalSupport from "./addInternalSupport";
// import Otp from '../home/otp';

const SetupInterceptors = () => {
  let history = useHistory();
  const location = useLocation();
  http.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      let message =
        error &&
        error.toJSON().message &&
        error.toJSON().message.indexOf("401") > -1
          ? "Session Expired..!"
          : error && error.toJSON().message && error.toJSON().message
          ? error.toJSON().message
          : "Bad Gateway..!";
      if (message === "Session Expired..!") {
        let count = localStorage.getItem("logOut");
        if (location.pathname !== "/") {
          history.push("/");
        }
      }
      return Promise.reject(error);
    }
  );
};
export default function Dashboard() {
  SetupInterceptors();
  let history = useHistory();

  let match = useRouteMatch();
  const location = useLocation();
  const [toggle, setToggle] = useState(false);
  const toggleDrawer = (e) => {
    setToggle(!toggle);
  };
  useEffect(() => {
    if (window.screen.width > 960) {
      setToggle(true);
    }
  }, []);
  return (
    <React.Fragment>
      <Box display="flex" flexDirection="column" className="dashboard">
        <Box component="header" style={{ height: 75 }}>
          <MenuBar toggleDrawer={toggleDrawer} />
        </Box>
        <Box component="section" display="flex" justifyContent="center">
          <Box component="aside">
            <SideBar toggle={toggle} setToggle={setToggle} />
          </Box>
          <Box
            component="article"
            style={
              !toggle
                ? { width: "100%", position: "relative", left: -100 }
                : { width: "80%" }
            }
          >
            {/* <Breadcrumb /> */}

            <Switch>
              <PrivateRoute path={prospectPath} component={Prospect} />
              {/* <PrivateRoute path={otpPath} component={Otp} /> */}
              <PrivateRoute path={addProspectPath} component={AddProspect} />

              <PrivateRoute
                path={viewInternalSupportPath}
                component={ViewInternalSupport}
              />
              <PrivateRoute
                path={createfranchisepath}
                component={createFranchise}
              />

              <PrivateRoute path={uploadecxel} component={Uploadexcel} />

              <PrivateRoute
                path={viewmissalesreportall}
                component={MisSalesReportParent}
              />
              <PrivateRoute
                path={viewmissalesreportsdetailsPath}
                component={MisSalesReportChild}
              />

              <PrivateRoute
                path={viewSalesMisReportsPath}
                component={MisSalesReport}
              />

              <PrivateRoute path={marketingpath} component={Marketing} />

              <PrivateRoute
                path={marketingparentpath}
                component={Marketparent}
              />

              <PrivateRoute
                path={viewSalesReportsPath}
                component={ViewSalesReports}
              />
              <PrivateRoute
                path={viewResearchReportsPath}
                component={ViewResearchReports}
              />
              <PrivateRoute
                path={createAdviseRequestPath}
                component={CreateAdviseRequest}
              />
              <PrivateRoute path={AddAdviseRequestPath} component={Addadvice} />

              {/*MANUAL ADVICE SECTIONS */}
              <PrivateRoute
                path={manualAdviceTabsPath}
                component={ManualAdviceTabs}
              />
              <PrivateRoute
                path={advicesPendingPath}
                component={AdvicesPending}
              />
              <PrivateRoute
                path={adviceRequestsPath}
                component={AdviceRequests}
              />

              <PrivateRoute
                path={ViewCdtReportsPath}
                component={ViewCdtReports}
              />
              <PrivateRoute
                path={ViewCdtParticularPath}
                component={ViewParticularCdtReport}
              />
              <PrivateRoute
                path={ViewCDTyetToSubscribePath}
                component={ViewCDTReferralToSubscribe}
              />

              <PrivateRoute
                path={addInternalSupportPath}
                component={AddInternalSupport}
              />
              <PrivateRoute
                path={editInternalSupportPath}
                component={EditInternalSupport}
              />
              <PrivateRoute
                path={viewMitsReportsPath}
                component={ViewMITSReports}
              />
              <PrivateRoute
                path={viewMitsChildReportsPath}
                component={ViewChildMitReports}
              />

              <PrivateRoute
                path={ViewNestedChildMisReportsPath}
                component={ViewNestedChildMitReports}
              />

              <PrivateRoute path={addReviewPath} component={AddReview} />
              <PrivateRoute
                path={addInvestorReviewPath}
                component={AddReview}
              />
              <PrivateRoute path={editProspectPath} component={EditProspect} />
              <PrivateRoute
                path={addProspectTaskPath}
                component={ProspectTask}
              />
              <PrivateRoute path={addTicketPath} component={AddTicket} />
              <PrivateRoute path={editTicketPath} component={EditTicket} />
              <PrivateRoute path={addPaymentPath} component={AddPayment} />
              <PrivateRoute path={addDiscountPath} component={addDiscount} />
              <PrivateRoute path={activityLogPath} component={ActivityLog} />
              <PrivateRoute
                path={investorActivityLogPath}
                component={ActivityLog}
              />
              <PrivateRoute path={addTheme} component={AddTheme} />
              <PrivateRoute
                path={investmentProfilePath}
                component={InvestmentProfile}
              />
              <PrivateRoute
                path={referralDashboardPath}
                component={ReferralDashboard}
              />
              <PrivateRoute
                path={investmentReferalDashboardPath}
                component={ReferralDashboard}
              />
              <PrivateRoute path={editInvestmentPath} component={EditVantage} />
              <PrivateRoute
                path={prospectSatisfactionPath}
                component={ProspectSatisfaction}
              />
              <PrivateRoute
                path={personalProfilePath}
                component={PersonalProfile}
              />
              <PrivateRoute path={investmentPath} component={InvestmentTabs} />
              <PrivateRoute
                path={investmentPersonalProfilePath}
                component={InvestorPersonalProfile}
              />
              <PrivateRoute path={editInvestPath} component={EditInvestornew} />
              <PrivateRoute
                path={investmentAdvicePath}
                component={InvestmentAdvice}
              />
              <PrivateRoute
                path={investorInvestmentProfilePath}
                component={InvestorInvestmentProfile}
              />
              <PrivateRoute
                path={createNotificationPath}
                component={CreateNotification}
              />
              <PrivateRoute
                path={investorCreateNotificationPath}
                component={CreateNotification}
              />
              <PrivateRoute path={investmentsPath} component={Investments} />

              <PrivateRoute
                path={investmentDetailsPath}
                component={InvestmentDetails}
              />
              <PrivateRoute
                path={executiveListPath}
                component={Executivelist}
              />
              <PrivateRoute path={alltasks} component={Prospectalltasks} />
              <PrivateRoute path={invalltasks} component={InvAllTasklist} />
              <PrivateRoute
                path={propectexecutiveListPath}
                component={ProspectExecutivelist}
              />
              <PrivateRoute
                path={investmentAddPaymentPath}
                component={AddPayment}
              />
              <PrivateRoute
                path={investmentDiscountPath}
                component={addDiscount}
              />
              <PrivateRoute
                path={subscriptionManagerPath}
                component={SubscriptionManager}
              />
              <PrivateRoute
                path={subscriptiondetailsPath}
                component={Subscriptiondetails}
              />
              <PrivateRoute
                path={extendsubscriptionPath}
                component={ExtendSubscription}
              />
              <PrivateRoute
                path={investmentSatisfactionPath}
                component={ProspectSatisfaction}
              />
              <PrivateRoute path={lookupManagerPath} component={LookupMaster} />
              <PrivateRoute path={addLookupManagerPath} component={AddLookup} />
              <PrivateRoute
                path={addContentManagementPath}
                component={AddCMS}
              />
              <PrivateRoute
                path={contentManagementPath}
                component={CMSOverView}
              />
              <PrivateRoute
                path={prospectDetailsPath}
                component={ProspectDetails}
              />
              <PrivateRoute
                path={communicatioTimeLinePath}
                component={CommunicationTimeLine}
              />
              <PrivateRoute
                path={investorcommunicationTimeLinePath}
                component={CommunicationTimeLine}
              />

              <PrivateRoute
                path={addCommunicatioTimeLinePath}
                component={AddCommunicatioTimeLine}
              />
              <PrivateRoute
                path={investorAddCommunicatioTimeLinePath}
                component={AddCommunicatioTimeLine}
              />
              <PrivateRoute
                path={callRequestsTabsPath}
                component={TabsCallRequest}
              />
              <PrivateRoute
                path={prospectcallRequestsPath}
                component={ProspectCallRequest}
              />
              <PrivateRoute
                path={investorcallRequestsPath}
                component={InvestorCallRequest}
              />
              <PrivateRoute
                path={brokerManagerPath}
                component={BrokerManager}
              />
              <PrivateRoute
                path={userManagementPath}
                component={UserManagementTabs}
              />
              <PrivateRoute path={vantagePath} component={SavVantageTabs} />
              <PrivateRoute
                path={addInvestmentPath}
                component={AddInvestment}
              />
              <PrivateRoute
                path={referralManagerPath}
                component={ReferralManager}
              />
              <PrivateRoute
                path={myPerformancePath}
                component={MyPerformance}
              />
              <PrivateRoute path={createEmailPath} component={CreateEmail} />
              <PrivateRoute
                path={investorCreateEmailPath}
                component={CreateEmail}
              />

              <PrivateRoute
                path={investorPortFolioPath}
                component={InvestorPortFolio}
              />
              <PrivateRoute
                path={editInvestorQuestioner}
                component={EditInvestor}
              />
              <PrivateRoute path={beigeManagementPath} component={BeigeTabs} />
              <PrivateRoute
                path={goalsDashboardPath}
                component={GoalsDashboard}
              />
              <PrivateRoute
                path={prospectGoalsDashboardPath}
                component={GoalsDashboard}
              />

              <PrivateRoute path={editUserPath} component={EditUser} />
              <PrivateRoute
                path={referralDashboardOverViewPath}
                component={ReferralDashboard}
              />
              <PrivateRoute path={addEFG} component={AddEfg} />
              <PrivateRoute path={editEFG} component={EditEFG} />
              <PrivateRoute
                path={editContentManagementPath}
                component={EditCMS}
              />
              <PrivateRoute
                path={addDiscountOverAllPath}
                component={AddDiscountRequest}
              />
              <PrivateRoute
                path={investorNotifiCationManagerPath}
                component={InvestorNotifiCationManager}
              />
              <PrivateRoute
                path={investorindividualRequestPath}
                component={InvestmentReviewTabs}
              />
              <PrivateRoute
                path={addNotificationPath}
                component={AddNotificationRequest}
              />
              <PrivateRoute path={landingpage2Path} component={LandingPage2} />

              <PrivateRoute path={razorpyPath} component={Razorpy} />

              <PrivateRoute path={gromocodepathPath} component={Gromolink} />

              <PrivateRoute
                path={menuuploadpathPath}
                component={MutualfundUpload}
              />

              <PrivateRoute
                path={franchiseDashboard}
                component={FranchiseDashboard}
              />

              <PrivateRoute
                path={addSubscriptionPath}
                component={AddSubscription}
              />
              <PrivateRoute
                path={investmentAddSubscriptionPath}
                component={AddSubscription}
              />
              <PrivateRoute path={delrequestspath} component={DeleteRequest} />
              {/* Re-assign rm comments list view  */}
              <PrivateRoute path={reassignRmList} component={ReAssignRmList} />

              {/*  Notes Review section */}
              <PrivateRoute path={notesReview} component={NotesReview} />

              <PrivateRoute
                path={rebalance_sell_path}
                component={RebalanceSell}
              />

              <PrivateRoute
                path={rebalance_data_path}
                component={RebalanceOverallData}
              />

              {/* GOAL ADVICES STOPPED */}
              <PrivateRoute component={GoalAdvices} path={goalAdvicesStopped} />

              {/*  Notes Review section */}
              <PrivateRoute
                path={addpaymentlinks}
                component={Addpaymentlinks}
              />
              {/* Rebalance Advice Button Path */}
              <PrivateRoute
                path={rebalanceAdvicePath}
                component={RebalanceAdvice}
              />

              <PrivateRoute path={checkstatutracking} component={CheckStatus} />

              <PrivateRoute
                path={cdt_create_advice}
                component={Cdtcreateadvicetabs}
              />

              <PrivateRoute path={auapath} component={Aua} />
              {/* Portfolio Review Tabs Path */}
              <PrivateRoute
                path={portfolioReviewTabsPath}
                component={PortfolioReview}
              />
              {/* Sent Portfolio Review Path */}
              <PrivateRoute
                path={sentportfolioReviewPath}
                component={SentportfolioReview}
              />
              {/* Add Portfolio Review Path */}
              <PrivateRoute
                path={addportfolioReviewPath}
                component={AddportfolioReview}
              />
              {/* Detail View Portfolio Review Path */}
              <PrivateRoute
                path={detailviewportfolioReviewPath}
                component={DetailviewportfolioReview}
              />
              {/* Sent Detail View Portfolio Review Path */}
              <PrivateRoute
                path={sentdetailviewportfolioReviewPath}
                component={SentdetailviewportfolioReview}
              />
              <PrivateRoute
                path={pendingportfolioReviewPath}
                component={PendingportfolioReview}
              />

              <PrivateRoute
                path={onboardingoverviewPath}
                component={OnboardingTabs}
              />
            </Switch>
          </Box>
        </Box>
      </Box>
    </React.Fragment>
  );
}
